import { Suspense } from "react";
import { RouteObject } from "react-router";

import Spinner from "@/shared/ui/Spinner";
import PageError from "@/shared/ui/errors/PageError";
import RouteErrorBoundary from "@/shared/ui/errors/RouteErrorBoundary";
import * as Sentry from "@sentry/react";

export const measurementsRoutes: RouteObject = {
	path: "/measurements/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { MeasurementsHomePage } = await import("./pages");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={(boundary) => (
								<PageError
									error={boundary.error}
									componentStack={boundary.componentStack}
									reset={() => boundary.resetError()}
								/>
							)}
						>
							<Suspense
								fallback={<Spinner text="Loading Measurements Home Page" />}
							>
								<MeasurementsHomePage />
							</Suspense>
						</Sentry.ErrorBoundary>
					),
					ErrorBoundary: RouteErrorBoundary,
				};
			},
		},
	],
};
